module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.ad_obj.id) ? _c('div', {
    staticClass: "promotion-campaign-filters promotion-table-filters ad-d-flex ad-d-flex-between"
  }, [_c('div', {
    staticClass: "promotion-table-filters-left-part ad-d-flex ad-d-flex-start"
  }, [_c('div', {
    staticClass: "ad-d-flex"
  }, [(_vm.ad_obj.id) ? _c('el-tag', {
    attrs: {
      "type": "info",
      "closable": ""
    },
    on: {
      "close": _vm.allCreative
    }
  }, [_vm._v("已选计划:" + _vm._s(_vm.ad_obj.name))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "",
      "label": "创意ID",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t" + _vm._s(scope.row.creative_id) + "\t\t\t\t\n\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "",
      "label": "素材类型",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t" + _vm._s(scope.row.image_mode_name) + "\t\t\t\t\n\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "",
      "label": "广告创意",
      "align": "left",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right",
            "width": "400",
            "trigger": "hover"
          }
        }, [_c('el-row', [_c('div', {
          staticClass: "image-background",
          on: {
            "click": function($event) {
              return _vm.preview(scope.row)
            }
          }
        }, [_c('img', {
          attrs: {
            "src": scope.row.image_url
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "image-content",
          staticStyle: {
            "width": "80px",
            "height": "45px",
            "padding": "5px 5px"
          },
          attrs: {
            "slot": "reference"
          },
          on: {
            "click": function($event) {
              return _vm.preview(scope.row)
            }
          },
          slot: "reference"
        }, [_c('img', {
          staticClass: "image-preview",
          attrs: {
            "src": scope.row.image_url
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "video-player",
          attrs: {
            "src": "//s1.pstatp.com/bytecom/platform_web/static/image/play.svg?f3db861d10cf31d0ff0778b1b4331ba9"
          }
        })])], 1), _vm._v(" "), _c('div', {
          staticClass: "creative-title multiple-line-txt-cut"
        }, [_vm._v(_vm._s(scope.row.title))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "广告创意状态",
      "align": "center",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 'CREATIVE_STATUS_DELIVERY_OK') ? _c('span', [_c('i', {
          staticClass: "fa fa-circle",
          staticStyle: {
            "color": "#4dd599",
            "font-size": "7px",
            "margin-right": "2px"
          }
        }), _vm._v(" " + _vm._s(scope.row.statusName))]) : _c('span', [_c('i', {
          staticClass: "fa fa-circle",
          staticStyle: {
            "color": "#999",
            "font-size": "7px",
            "margin-right": "2px"
          }
        }), _vm._v(" " + _vm._s(scope.row.statusName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.cost",
      "label": "消耗(元)",
      "sortable": "",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.show",
      "sortable": "",
      "label": "展示",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.click",
      "sortable": "",
      "label": "点击",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.convert",
      "sortable": "",
      "label": "转化数",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.cpi",
      "sortable": "",
      "label": "CPI",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.cpm",
      "sortable": "",
      "label": "CPM",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.ctr",
      "sortable": "",
      "label": "CTR(%)",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.cvr",
      "sortable": "",
      "label": "CVR(%)",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属广告计划",
      "align": "center",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-link', {
          staticStyle: {
            "font-size": "12px"
          },
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(scope.row.report.ad_name))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "disabled": this.sels.length === 0,
      "icon": "el-icon-check",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.updateStatus('enable')
      }
    }
  }, [_vm._v("开启")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning",
      "icon": "el-icon-video-pause",
      "disabled": this.sels.length === 0,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.updateStatus('disable')
      }
    }
  }, [_vm._v("暂停")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,sizes,prev, pager, next",
      "page-size": _vm.pagesize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-680d8271"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adv/model/creative.vue
// module id = 1104
// module chunks = 36